import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonDynamicTablePagination from "../../../../common/components/CommonTable/CommonMasterPaginationTable";

import HandymanOutlinedIcon from "@mui/icons-material/HandymanOutlined";
import SearchIcon from "@mui/icons-material/Search";
import UpdateIcon from "@mui/icons-material/Update";
import InputAdornment from "@mui/material/InputAdornment";
// ✅ ACTION ICONS
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import {
  agentSearchDropdown,
  AMCAgentSearchDropdown,
  AmcListing,
  AMCTypeSearchDropdown,
  approveCondemnation,
  approveTransfer,
  approveTransferList,
  BatchNoSearchDropdown,
  companySearchDropdown,
  departmentNameSearchDropdown,
  EmployeeSearchDropdown,
  fetchAllocateSaveData,
  fetchAmcSaveData,
  fetchinsuranceSaveData,
  fetchSaveTransfertData,
  FromToSearchDropdown,
  getPendingCondemnationList,
  InsuranceListing,
  InsuranceTypeSearchDropdown,
  ItemInfoListing,
  ItemNameSearchDropdown,
  MaintenanceListing,
  MaintenanceTypeSearchDropdown,
  ModelNoSearchDropdown,
  requestCondemnation,
  searchItemNameDropdown,
  searchSerialNoDropdown,
  SerialNoSearchDropdown,
  UpdateListing,
  UplodasExcelSaveData,
} from "../../../services/iteminfoservices/Iteminfolistservices";

import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import CallSplitOutlinedIcon from "@mui/icons-material/CallSplitOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HealthAndSafetyOutlinedIcon from "@mui/icons-material/HealthAndSafetyOutlined";
import dayjs from "dayjs";

import { CloseModalIcon } from "../../../../common/components/assets/commonassets/CommonAssets";
import CommonTransactionPaginationTable from "../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import DatePickerField from "../../../../common/components/FormFields/DatePickerFieldNew";
import InputField from "../../../../common/components/FormFields/InputField";
import MaintenanceDialog from "./MaintenanceDialog";
import UpdateDialog from "./UpdateDialog";
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

export default function ItemInfoList() {
  const [dataResult, setDataResult] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [batchNo, setBatchNo] = useState("");
  const [modelNo, setModelNo] = useState("");
  const [serialNo, setSerialNo] = useState("");
  const [locationType, setLocationType] = useState("");
  const [itemSearch, setItemSearch] = useState("");
  const [openAllocation, setOpenAllocation] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [employeeLoading, setEmployeeLoading] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [openTransfer, setOpenTransfer] = useState(false);
  const [deptOptions, setDeptOptions] = useState([]);
  const [deptLoading, setDeptLoading] = useState(false);
  const [fromDept, setFromDept] = useState(null);
  const [toDept, setToDept] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [allocationTableData, setAllocationTableData] = useState([]);
  const [allocationCount, setAllocationCount] = useState(0);
  const [openAllocateConfirm, setOpenAllocateConfirm] = useState(false);
  const [openApproval, setOpenApproval] = useState(false);
  const [itemOptions, setItemOptions] = useState([]);
  const [serialOptions, setSerialOptions] = useState([]);
  const [approvalTableData, setApprovalTableData] = useState([]);
  const [openApproveConfirm, setOpenApproveConfirm] = useState(false);
  const [selectedApprovalRow, setSelectedApprovalRow] = useState(null);
  const [transferDate, setTransferDate] = useState(dayjs());
  const [showForm, setShowForm] = React.useState(false);
  const [insuranceDialogOpen, setInsuranceDialogOpen] = React.useState(false);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [insuranceItemInfoId, setInsuranceItemInfoId] = useState(null);
  const [insuranceType, setInsuranceType] = useState(null);
  const [insuranceTypeOptions, setInsuranceTypeOptions] = useState([]);
  const [insuranceTypeLoading, setInsuranceTypeLoading] = useState(false);
  const [insuranceCompany, setInsuranceCompany] = useState(null);
  const [insuranceCompanyOptions, setInsuranceCompanyOptions] = useState([]);
  const [insuranceCompanyLoading, setInsuranceCompanyLoading] = useState(false);
  const [insuranceAgent, setInsuranceAgent] = useState(null);
  const [insuranceAgentOptions, setInsuranceAgentOptions] = useState([]);
  const [insuranceAgentLoading, setInsuranceAgentLoading] = useState(false);
  const [openInsuranceConfirm, setOpenInsuranceConfirm] = useState(false);
  const [insuranceNo, setInsuranceNo] = useState("");
  const [insuranceAmount, setInsuranceAmount] = useState("");
  const [premiumAmount, setPremiumAmount] = useState("");
  const [premiumDate, setPremiumDate] = useState("");
  const [validFromDate, setValidFromDate] = useState("");
  const [validToDate, setValidToDate] = useState("");
  const [referenceNo, setReferenceNo] = useState("");
  const [remark, setRemark] = useState("");
  const [amcDialogOpen, setAmcDialogOpen] = useState(false);
  const [amcShowForm, setAmcShowForm] = useState(false);
  const [openAmcConfirm, setOpenAmcConfirm] = useState(false);
  const [amcRows, setAmcRows] = useState([]);
  const [amcLoading, setAmcLoading] = useState(false);
  const [amcItemInfoId, setAmcItemInfoId] = useState(null);
  const [amcNo, setAmcNo] = useState("");
  const [amcType, setAmcType] = useState(null);
  const [amcAmountValue, setAmcAmountValue] = useState("");
  const [amcDate, setAmcDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [annualGuaranty, setAnnualGuaranty] = useState("");
  const [perVisitCharge, setPerVisitCharge] = useState("");
  const [maintenanceType, setMaintenanceType] = useState(null);
  const [lastMaintenanceDate, setLastMaintenanceDate] = useState("");
  const [amcAgent, setAmcAgent] = useState(null);
  const [amcTypeOptions, setAmcTypeOptions] = useState([]);
  const [maintenanceTypeOptions, setMaintenanceTypeOptions] = useState([]);
  const [amcAgentOptions, setAmcAgentOptions] = useState([]);
  const [amcTypeLoading, setAmcTypeLoading] = useState(false);
  const [maintenanceTypeLoading, setMaintenanceTypeLoading] = useState(false);
  const [amcAgentLoading, setAmcAgentLoading] = useState(false);
  const [itemText, setItemText] = useState("");
  const [batchText, setBatchText] = useState("");
  const [modelText, setModelText] = useState("");
  const [serialText, setSerialText] = useState("");
  const [batchOptions, setBatchOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [file, setFile] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [maintenanceDialogOpen, setMaintenanceDialogOpen] = useState(false);
  const [updateDialogOpen, setUpdateDialogOpen] = useState(false);
  const [maintenanceShowForm, setMaintenanceShowForm] = useState(false);
  const [updateShowForm, setUpdateShowForm] = useState(false);
  const [maintenanceRows, setMaintenanceRows] = useState([]);
  const [updateRows, setUpdateRows] = useState([]);
  const [maintenanceLoading, setMaintenanceLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const [maintenanceItemInfoId, setMaintenanceItemInfoId] = useState(null);
  const [updateItemInfoId, setUpdateItemInfoId] = useState(null);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedItemInfoId, setSelectedItemInfoId] = useState(null);
  const [approvalLoading, setApprovalLoading] = React.useState(false);
  const [condemnationStatus, setCondemnationStatus] = useState({});
  const [openCondemnConfirm, setOpenCondemnConfirm] = useState(false);
  const [selectedCondemnRow, setSelectedCondemnRow] = useState(null);
  const [openCondemnApproval, setOpenCondemnApproval] = useState(false);
  const [condemnApprovalRows, setCondemnApprovalRows] = useState([]);
  const [selectedCondemnApprovalRow, setSelectedCondemnApprovalRow] =
    useState(null);
  const [condemnApprovalLoading, setCondemnApprovalLoading] = useState(false);
  const [openCondemnApproveConfirm, setOpenCondemnApproveConfirm] =
    useState(false);
  const [approvalError, setApprovalError] = useState("");
  const [transferStatus, setTransferStatus] = useState({});
  const [selectedItemDetails, setSelectedItemDetails] = useState(null);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [locationValue, setLocationValue] = useState(null);
  const [locationText, setLocationText] = useState("");
  const [isParentPass, setIsParentPass] = useState(false);
  const [isOtherPass, setIsOtherPass] = useState(false);

  const locationOptions = [
    { id: 1, value: "Parent Location", label: "Parent Location" },
    { id: 2, value: "Other Location", label: "Other Location" },
  ];
  // filterLocationId

  const userInfoResult = JSON.parse(localStorage.getItem("userInfo"));
  console.log("userInfoResultuserInfoResultuserInfoResult", userInfoResult);

  const fileInputRef = React.useRef(null);

  const openMaintenanceDialog = (row) => {
    const id =
      row?.itemInfoId ??
      row?.ItemInfoId ??
      row?.iteminfoid ??
      row?.["ItemInfo Id"];

    setMaintenanceItemInfoId(id);
    setSelectedItemDetails(row);
    setMaintenanceDialogOpen(true);
  };

  const itemInfoId =
    selectedApprovalRow?.itemInfoId ??
    selectedApprovalRow?.ItemInfoId ??
    selectedApprovalRow?.iteminfoid ??
    selectedApprovalRow?.["ItemInfo Id"];

  const { control, reset, getValues } = useForm({
    defaultValues: {
      insuranceNo: "",
      insuranceType: null,
      insuranceAmount: "",
      referenceNo: "",
      validFromDate: null,
      validToDate: null,
      premiumAmount: "",
      premiumDate: null,
      insuranceCompany: null,
      insuranceAgent: null,
      remark: "",
      transferDate: new Date(),
    },
  });

  const clearInsuranceForm = () => {
    setInsuranceNo("");
    setInsuranceType(null);
    setInsuranceAmount("");
    setReferenceNo("");
    setValidFromDate(null);
    setValidToDate(null);
    setPremiumAmount("");
    setPremiumDate(null);
    setInsuranceCompany(null);
    setInsuranceAgent(null);
    setRemark("");
  };

  const getItemInfoId = (row) => {
    return row?.itemInfoId ?? row?.ItemInfoId ?? row?.["ItemInfo Id"] ?? null;
  };

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const confirmUpload = async () => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("file", file);

      const res = await UplodasExcelSaveData(formData);

      const { statusCode, message } = res.data;

      setConfirmOpen(false);
      setShowModal(false);

      if (statusCode === 200) {
        // ✅ SUCCESS
        setSnack({
          open: true,
          message,
          severity: "success",
        });

        // clear file
        setFile(null);
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        setSnack({
          open: true,
          message,
          severity: "error",
        });
      }
    } catch (error) {
      setConfirmOpen(false);
      setShowModal(false);

      setSnack({
        open: true,
        message:
          error?.response?.data?.message ||
          "Something went wrong while uploading",
        severity: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const [iteminsuranceDetails, setInvertGRNDetails] = React.useState({
    ItemName: "",
    ItemCode: "",
    DepartmentId: "",
    GRNDate: "",
    InstalledDate: "",
  });

  const [amcItemDetails, setAmcItemDetails] = useState({
    ItemName: "",
    ItemCode: "",
    DepartmentId: "",
    GRNDate: "",
    InstalledDate: "",
  });

  const DrawerHeader = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  }));

  const buildInsurancePayload = () => ({
    id: null,
    itemInfoId: insuranceItemInfoId,
    insuranceNo: insuranceNo,
    insuranceAmount: Number(insuranceAmount || 0),
    premiumAmount: Number(premiumAmount || 0),
    premiumDate: premiumDate,
    insuranceCompanyId: insuranceCompany?.id,
    fromDate: validFromDate,
    toDate: validToDate,
    insuranceAgentId: insuranceAgent?.id,
    insuranceTypeId: insuranceType?.id,
    referenceNumber: referenceNo,
    remark: remark,
  });

  const buildAmcPayload = () => ({
    id: null,
    itemInfoId: amcItemInfoId,
    amcNo: amcNo,
    amcTypeId: amcType?.id,
    amcAmountValue: Number(amcAmountValue || 0),
    amcDate: amcDate,
    fromDate: fromDate,
    toDate: toDate,
    annualGuaranty: annualGuaranty,
    perVisitCharge: Number(perVisitCharge || 0),
    maintenanceTypeId: maintenanceType?.id,
    lastMaintenanceDate: lastMaintenanceDate,
    amcAgentId: amcAgent?.id,
    remark: remark,
  });

  const fetchDepartmentNames = async (text) => {
    if (!text) return;

    try {
      const res = await departmentNameSearchDropdown(text);

      setDepartmentOptions(
        Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.data?.result)
            ? res.data.result
            : [],
      );
    } catch (e) {
      setDepartmentOptions([]);
    }
  };

  const fetchEmployees = async (searchText, reason) => {
    if (reason !== "input") return;
    if (!searchText) return;

    setEmployeeLoading(true);
    try {
      const res = await EmployeeSearchDropdown(encodeURIComponent(searchText));
      setEmployeeOptions(Array.isArray(res?.data) ? res.data : []);
    } catch (error) {
      console.error("Employee search error", error);
      setEmployeeOptions([]);
    } finally {
      setEmployeeLoading(false);
    }
  };

  const fetchDepartments = async (searchText, reason) => {
    if (reason !== "input") return;
    if (!searchText) return;

    setDeptLoading(true);
    try {
      const res = await FromToSearchDropdown(encodeURIComponent(searchText));

      setDeptOptions(Array.isArray(res?.data) ? res.data : []);
    } catch (error) {
      console.error("Department search error", error);
      setDeptOptions([]);
    } finally {
      setDeptLoading(false);
    }
  };

  const fetchItems = async (text, reason) => {
    if (reason !== "input" || !text) return;
    const res = await searchItemNameDropdown(text);
    setItemOptions(res?.data || []);
  };

  const fetchSerials = async (text, reason) => {
    if (reason !== "input" || !text) return;
    const res = await searchSerialNoDropdown(text);
    setSerialOptions(res?.data || []);
  };

  const fetchInsuranceTypes = async (searchText, reason) => {
    if (reason !== "input") return;

    setInsuranceTypeLoading(true);
    try {
      const res = await InsuranceTypeSearchDropdown(
        encodeURIComponent(searchText || ""),
      );
      setInsuranceTypeOptions(Array.isArray(res?.data) ? res.data : []);
    } finally {
      setInsuranceTypeLoading(false);
    }
  };

  const fetchInsuranceCompanies = async (searchText, reason) => {
    if (reason !== "input") return;

    setInsuranceCompanyLoading(true);
    try {
      const res = await companySearchDropdown(
        encodeURIComponent(searchText || ""),
      );
      setInsuranceCompanyOptions(Array.isArray(res?.data) ? res.data : []);
    } finally {
      setInsuranceCompanyLoading(false);
    }
  };

  const fetchInsuranceAgents = async (searchText, reason) => {
    if (reason !== "input") return;
    if (!insuranceCompany?.id) return;

    setInsuranceAgentLoading(true);
    try {
      const res = await agentSearchDropdown(insuranceCompany.id, searchText);
      setInsuranceAgentOptions(Array.isArray(res?.data) ? res.data : []);
    } finally {
      setInsuranceAgentLoading(false);
    }
  };

  const fetchAmcTypes = async (searchText, reason) => {
    if (reason !== "input") return;

    setAmcTypeLoading(true);
    try {
      const res = await AMCTypeSearchDropdown(searchText || "");
      setAmcTypeOptions(res?.data || []);
    } catch (e) {
      setAmcTypeOptions([]);
    } finally {
      setAmcTypeLoading(false);
    }
  };

  const fetchMaintenanceTypes = async (searchText, reason) => {
    if (reason !== "input") return;

    setMaintenanceTypeLoading(true);
    try {
      const res = await MaintenanceTypeSearchDropdown(searchText || "");
      setMaintenanceTypeOptions(res?.data || []);
    } finally {
      setMaintenanceTypeLoading(false);
    }
  };

  const fetchAmcAgents = async (searchText, reason) => {
    if (reason !== "input") return;

    setAmcAgentLoading(true);
    try {
      const res = await AMCAgentSearchDropdown(searchText || "");
      setAmcAgentOptions(res?.data || []);
    } finally {
      setAmcAgentLoading(false);
    }
  };

  const updateRowInTable = (updatedRow) => {
    setDataResult((prev) =>
      prev.map((row) => {
        const rowId =
          row?.itemInfoId ?? row?.ItemInfoId ?? row?.["ItemInfo Id"];

        if (rowId !== updatedRow.id) return row;

        return {
          ...row,
          "Item Name": updatedRow.itemName,
          "Asset Make": updatedRow.assetMake,
          "Batch No": updatedRow.batchNo,
          "Model No": updatedRow.modelNo,
          "Serial No": updatedRow.serialNo,
          Location: updatedRow.location,
        };
      }),
    );
  };

  const populateTable = (forPagination) => {
    const locationType =
      locationValue?.value === "Parent Location"
        ? true
        : locationValue?.value === "Other Location"
          ? false
          : null;

    const filterLocationId = userInfoResult?.cashCounterId;

    const searchString = [
      itemSearch && `itemName:${itemSearch}`,
      batchNo && `batchNo:${batchNo}`,
      modelNo && `modelNo:${modelNo}`,
      serialNo && `serialNo:${serialNo}`,
      locationType !== null && `locationType:${locationType}`,
    ]
      .filter(Boolean)
      .join(",");

    const payload = {
      description: itemText?.trim() || null,
      batchNo: batchText?.trim() || null,
      modelNo: modelText?.trim() || null,
      serialNo: serialText?.trim() || null,
      isParentLocation: locationType,
      filterLocationId,
      page: page,
      size: rowsPerPage,
    };

    setOpenBackdrop(true);

    ItemInfoListing(payload)
      .then((response) => {
        const res = response.data;
        if (forPagination) {
          setDataResult((prevData) => [...prevData, ...res?.result]);
        } else {
          setDataResult(res?.result ?? []);
        }
        setCount(res?.count ?? 0);
      })
      .catch((error) => {
        setOpenBackdrop(false);
        console.error("Item listing error:", error);
      })
      .finally(() => {
        setOpenBackdrop(false);
      });
  };

  const formatDate = (date) => {
    if (!date) return "-";
    return dayjs(date).format("YYYY-MM-DD");
  };

  useEffect(() => {
    if (!openCondemnApproval || !selectedItemInfoId) return;

    const fetchCondemnPendingList = async () => {
      try {
        setCondemnApprovalLoading(true);

        const res = await getPendingCondemnationList(selectedItemInfoId);

        const rows = Array.isArray(res?.data?.result)
          ? res.data.result
          : Array.isArray(res?.data)
            ? res.data
            : [];

        setCondemnApprovalRows(rows);
        if (rows.length > 0) {
          setSelectedCondemnApprovalRow(rows[0]);
        }
      } catch (error) {
        setCondemnApprovalRows([]);
        setSelectedCondemnApprovalRow(null);
      } finally {
        setCondemnApprovalLoading(false);
      }
    };

    fetchCondemnPendingList();
  }, [openCondemnApproval, selectedItemInfoId]);

  useEffect(() => {
    if (showModal) {
      setFile(null);

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  }, [showModal]);

  useEffect(() => {
    if (!openApproval || !selectedItemInfoId) return;

    const fetchApprovalList = async () => {
      try {
        setApprovalLoading(true);

        const payload = { isTransferApproved: false };
        const res = await approveTransferList(selectedItemInfoId, payload);

        const rows = Array.isArray(res?.data?.result)
          ? res.data.result
          : Array.isArray(res?.data)
            ? res.data
            : [];

        setApprovalTableData(rows);
        if (rows.length > 0) {
          setSelectedApprovalRow(rows[0]);
        }
      } catch (error) {
        console.error("Transfer approval fetch failed", error);
        setApprovalTableData([]);
        setSelectedApprovalRow(null);
      } finally {
        setApprovalLoading(false);
      }
    };

    fetchApprovalList();
  }, [openApproval, selectedItemInfoId]);

  useEffect(() => {
    populateTable();
  }, []);

  useEffect(() => {
    console.log("EMPLOYEE OPTIONS >>>", employeeOptions);
  }, [employeeOptions]);

  useEffect(() => {
    if (openTransfer) {
      setTransferDate(dayjs());
    }
  }, [openTransfer]);

  useEffect(() => {
    if (!insuranceItemInfoId) return;

    setLoading(true);

    InsuranceListing(insuranceItemInfoId)
      .then((res) => {
        const data = res?.data;

        if (Array.isArray(data)) {
          setRows(data);
        } else if (Array.isArray(data?.result)) {
          setRows(data.result);
        } else {
          setRows([]);
        }
      })
      .catch((err) => {
        console.error("Insurance API error", err);
        setRows([]);
      })
      .finally(() => setLoading(false));
  }, [insuranceItemInfoId]);

  useEffect(() => {
    setInsuranceAgent(null);
    setInsuranceAgentOptions([]);
  }, [insuranceCompany]);

  useEffect(() => {
    if (!amcItemInfoId) return;

    setAmcLoading(true);

    AmcListing(amcItemInfoId)
      .then((res) => {
        const data = res?.data;

        if (Array.isArray(data)) {
          setAmcRows(data);
        } else if (Array.isArray(data?.result)) {
          setAmcRows(data.result);
        } else {
          setAmcRows([]);
        }
      })
      .catch(() => {
        setAmcRows([]);
      })
      .finally(() => setAmcLoading(false));
  }, [amcItemInfoId]);

  useEffect(() => {
    if (!itemText) {
      setItemOptions([]);
      return;
    }

    const t = setTimeout(() => {
      ItemNameSearchDropdown(itemText)
        .then((res) => {
          setItemOptions(res?.data?.result ?? []);
        })
        .catch(() => setItemOptions([]));
    }, 400);

    return () => clearTimeout(t);
  }, [itemText]);

  useEffect(() => {
    if (!maintenanceItemInfoId) return;

    setMaintenanceLoading(true);

    MaintenanceListing(maintenanceItemInfoId)
      .then((res) => {
        const data = res?.data;
        if (Array.isArray(data)) {
          setMaintenanceRows(data);
        } else if (Array.isArray(data?.result)) {
          setMaintenanceRows(data.result);
        } else {
          setMaintenanceRows([]);
        }
      })
      .catch(() => setMaintenanceRows([]))
      .finally(() => setMaintenanceLoading(false));
  }, [maintenanceItemInfoId]);

  useEffect(() => {
    if (!updateItemInfoId) return;

    setUpdateLoading(true);

    UpdateListing(updateItemInfoId)
      .then((res) => {
        const data = res?.data;
        if (Array.isArray(data)) {
          setUpdateRows(data);
        } else if (Array.isArray(data?.result)) {
          setUpdateRows(data.result);
        } else {
          setUpdateRows([]);
        }
      })
      .catch(() => setUpdateRows([]))
      .finally(() => setUpdateLoading(false));
  }, [updateItemInfoId]);

  useEffect(() => {
    if (!batchText) {
      setBatchOptions([]);
      return;
    }

    const t = setTimeout(() => {
      BatchNoSearchDropdown(batchText)
        .then((res) => {
          setBatchOptions(res?.data?.result ?? []);
        })
        .catch(() => setBatchOptions([]));
    }, 400);

    return () => clearTimeout(t);
  }, [batchText]);

  useEffect(() => {
    if (!modelText) {
      setModelOptions([]);
      return;
    }

    const t = setTimeout(() => {
      ModelNoSearchDropdown(modelText)
        .then((res) => {
          setModelOptions(res?.data?.result ?? []);
        })
        .catch(() => setModelOptions([]));
    }, 400);

    return () => clearTimeout(t);
  }, [modelText]);

  useEffect(() => {
    if (!serialText) {
      setSerialOptions([]);
      return;
    }

    const t = setTimeout(() => {
      SerialNoSearchDropdown(serialText)
        .then((res) => {
          setSerialOptions(res?.data?.result ?? []);
        })
        .catch(() => setSerialOptions([]));
    }, 400);

    return () => clearTimeout(t);
  }, [serialText]);

  const RenderActions = (row) => (
    <div className="flex items-center gap-2">
      <Tooltip title="Update">
        <UpdateIcon
          sx={{ color: "#2e7d32", cursor: "pointer" }}
          onClick={() => {
            const id =
              row?.itemInfoId ??
              row?.ItemInfoId ??
              row?.iteminfoid ??
              row?.["ItemInfo Id"];

            if (!id) return;
            setUpdateItemInfoId(id);
            setTimeout(() => {
              setUpdateDialogOpen(true);
            }, 0);
          }}
        />
      </Tooltip>

      <Tooltip title="Maintenance">
        <HandymanOutlinedIcon
          sx={{ color: "#7b1fa2", cursor: "pointer" }}
          onClick={() => {
            const id =
              row?.itemInfoId ??
              row?.ItemInfoId ??
              row?.iteminfoid ??
              row?.["ItemInfo Id"];

            setMaintenanceItemInfoId(id);
            setSelectedItemDetails(row);
            setMaintenanceDialogOpen(true);
          }}
        />
      </Tooltip>

      <Tooltip title="Condemnation Request">
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (condemnationStatus[row["ItemInfo Id"]]) return;

            setSelectedCondemnRow(row);
            setOpenCondemnConfirm(true);
          }}
        >
          {condemnationStatus[row["ItemInfo Id"]] === "requested" ? (
            <CheckCircleIcon sx={{ color: "#1976d2" }} />
          ) : condemnationStatus[row["ItemInfo Id"]] === "approved" ? (
            <CheckCircleIcon sx={{ color: "green" }} />
          ) : (
            <AssignmentOutlinedIcon sx={{ color: "#ff6f00" }} />
          )}
        </span>
      </Tooltip>

      <Tooltip title="Condemnation Approval">
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (condemnationStatus[row["ItemInfo Id"]] === "approved") return;

            setSelectedItemInfoId(row["ItemInfo Id"]);
            setOpenCondemnApproval(true);
          }}
        >
          {condemnationStatus[row["ItemInfo Id"]] === "approved" ? (
            <CheckCircleIcon sx={{ color: "green" }} />
          ) : (
            <AssignmentOutlinedIcon sx={{ color: "#2e7d32" }} />
          )}
        </span>
      </Tooltip>

      <Tooltip title="Insurance">
        <HealthAndSafetyOutlinedIcon
          sx={{ cursor: "pointer", color: "#7b1fa2" }}
          onClick={() => {
            setInsuranceItemInfoId(row?.["ItemInfo Id"]);
            setInvertGRNDetails({
              ItemName: row?.["Item Name"] || "-",
              ItemCode: row?.["Item Id"] || "-",
              DepartmentId: row?.["Department Id"] || "-",
              GRNDate: row?.["GRN Date"] || "-",
              InstalledDate: row?.["Installation Date"] || "-",
            });

            setInsuranceDialogOpen(true);
            setShowForm(false);
          }}
        />
      </Tooltip>

      <Tooltip title="AMC">
        <BuildOutlinedIcon
          sx={{ color: "#ff6f00", cursor: "pointer" }}
          onClick={() => {
            setAmcItemInfoId(row?.["ItemInfo Id"]);

            setAmcItemDetails({
              ItemName: row?.["Item Name"] || "-",
              ItemCode: row?.["Item Id"] || "-",
              DepartmentId: row?.["Department Id"] || "-",
              GRNDate: row?.["GRN Date"] || "-",
              InstalledDate: row?.["Installation Date"] || "-",
            });

            setAmcDialogOpen(true);
            setAmcShowForm(false);
          }}
        />
      </Tooltip>

      <Tooltip title="Allocation">
        <CallSplitOutlinedIcon
          sx={{ color: "#1976d2", cursor: "pointer" }}
          onClick={() => {
            setSelectedRow(row);
            setOpenAllocation(true);
            setSelectedEmployee(null);
            setEmployeeOptions([]);
          }}
        />
      </Tooltip>

      <Tooltip title="Transfer Request">
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (transferStatus[row["ItemInfo Id"]]) return;
            setSelectedRow(row);
            setInvertGRNDetails({
              ItemName: row?.["Item Name"] || "",
              ItemCode: row?.["Item Code"] || "",
              DepartmentId: row?.["Department Id"] || "",
              GRNDate: row?.["GRN Date"] || "",
              InstalledDate: row?.["Installed Date"] || "",
            });
            setOpenTransfer(true);
            setFromDept({
              id: 45,
              label: "Purchase",
              value: "Purchase",
            });
            setToDept(null);
            setTransferDate(null);
          }}
        >
          {transferStatus[row["ItemInfo Id"]] === "requested" ? (
            <CheckCircleIcon sx={{ color: "#1976d2" }} />
          ) : transferStatus[row["ItemInfo Id"]] === "approved" ? (
            <CheckCircleIcon sx={{ color: "green" }} />
          ) : (
            <SwapHorizIcon sx={{ color: "#ff6f00" }} />
          )}
        </span>
      </Tooltip>

      <Tooltip title="Transfer Approval">
        <span
          style={{ cursor: "pointer" }}
          onClick={() => {
            if (transferStatus[row["ItemInfo Id"]] === "approved") return;

            setSelectedItemInfoId(row["ItemInfo Id"]);
            setOpenApproval(true);
          }}
        >
          {transferStatus[row["ItemInfo Id"]] === "approved" ? (
            <CheckCircleIcon sx={{ color: "green" }} />
          ) : (
            <SwapHorizIcon sx={{ color: "#2e7d32" }} />
          )}
        </span>
      </Tooltip>
    </div>
  );

  const commonAutocompleteSx = {
    "& .MuiOutlinedInput-root": {
      height: 38,
    },
    "& .MuiOutlinedInput-input": {
      padding: "8px 10px",
    },
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* <Sidebar /> */}

      <Box component="main" sx={{ flexGrow: 1, p: 4 }}>
        {/* <DrawerHeader /> */}

        <h1 className="text-xl text-black font-Poppins mb-4">
          Item Info Listing
        </h1>

        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            mb: 2,
            alignItems: "center",
          }}
        >
          <Autocomplete
            sx={{ width: 300, ...commonAutocompleteSx }}
            size="small"
            freeSolo
            openOnFocus
            value={null}
            inputValue={itemText}
            options={itemOptions || []}
            filterOptions={(options) => options}
            getOptionLabel={(option) => option.value || ""}
            onInputChange={(e, v) => setItemText(v)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Item Name"
                size="small"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <InputAdornment position="end">
                      {params.InputProps.endAdornment}
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />

          <Autocomplete
            sx={{ width: 240, ...commonAutocompleteSx }}
            size="small"
            freeSolo
            openOnFocus
            value={null}
            inputValue={batchText}
            options={batchOptions || []}
            filterOptions={(x) => x}
            getOptionLabel={(option) => option.value || ""}
            onInputChange={(e, v) => setBatchText(v)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Batch No"
                size="small"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon color="action" />
                      {params.InputProps.endAdornment}
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />

          <Autocomplete
            sx={{ width: 240, ...commonAutocompleteSx }}
            size="small"
            freeSolo
            openOnFocus
            value={null}
            inputValue={modelText}
            options={modelOptions || []}
            filterOptions={(x) => x}
            getOptionLabel={(option) => option.value || ""}
            onInputChange={(e, v) => setModelText(v)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Model No"
                size="small"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon color="action" />
                      {params.InputProps.endAdornment}
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />

          <Autocomplete
            sx={{ width: 240, ...commonAutocompleteSx }}
            size="small"
            freeSolo
            openOnFocus
            value={null}
            inputValue={serialText}
            options={serialOptions || []}
            filterOptions={(x) => x}
            getOptionLabel={(option) => option.value || ""}
            onInputChange={(e, v) => setSerialText(v)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Serial No"
                size="small"
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon color="action" />
                      {params.InputProps.endAdornment}
                    </InputAdornment>
                  ),
                }}
              />
            )}
          />

          <Autocomplete
            sx={{ width: 240, ...commonAutocompleteSx }}
            size="small"
            openOnFocus
            options={locationOptions}
            // defaultValue={locationOptions[0]}
            inputValue={locationText}
            getOptionLabel={(option) => option.value || ""}
            onChange={(e, newValue) => {
              console.log("newValuenewValuenewValue", newValue);

              setLocationValue(newValue);
              setLocationText(newValue?.value || "");
            }}
            onInputChange={(e, newInputValue) => {
              setLocationText(newInputValue);
            }}
            renderInput={(params) => (
              <TextField
                name={"location"}
                {...params}
                label="Location"
                size="small"
              />
            )}
          />

          <CommonButton
            searchIcon
            className="bg-blue-800 text-white"
            type="button"
            onClick={() => {
              setPage(0);
              populateTable();
            }}
          />

          <Button
            variant="outlined"
            color="error"
            onClick={() => {
              setItemText("");
              setBatchText("");
              setModelText("");
              setSerialText("");
              setItemOptions([]);
              setBatchOptions([]);
              setModelOptions([]);
              setSerialOptions([]);
              setPage(0);
            }}
          >
            Reset
          </Button>

          <Button
            sx={{ ml: "auto" }}
            variant="contained"
            color="success"
            onClick={() => setShowModal(true)}
            fullWidth={isMobile}
          >
            Excel
          </Button>
        </Box>

        <hr className="border-[#0B83A5] mb-3" />

        {dataResult.length > 0 ? (
          <CommonTransactionPaginationTable
            dataResult={dataResult}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            count={count}
            actionsRequired={true}
            renderActions={RenderActions}
            highlightRow={false}
            populateTable={populateTable}
            removeHeaders={["Sr No.", "srNo", "ItemInfo Id", "itemId"]}
          />
        ) : (
          <h2 className="text-center text-gray-600 mt-20">No Data Found</h2>
        )}

        <CommonBackDrop openBackdrop={openBackdrop} />
      </Box>

      {/* Allocation */}
      <Dialog
        open={openAllocation}
        onClose={() => setOpenAllocation(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            Allocate Item
            <CloseModalIcon
              onClick={() => {
                setOpenAllocation(false);
              }}
            />
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: 2,
              mt: 2,
            }}
          >
            <Autocomplete
              options={employeeOptions}
              value={selectedEmployee}
              filterOptions={(x) => x}
              getOptionLabel={(option) => option.label || ""}
              isOptionEqualToValue={(option, value) =>
                option.value === value?.value
              }
              onInputChange={(e, value, reason) => {
                if (reason === "input") {
                  fetchEmployees(value, reason);
                }
              }}
              onChange={(e, newValue) => {
                setSelectedEmployee(newValue);
                setEmployeeOptions([]);
              }}
              noOptionsText="No employee found"
              sx={{ width: { xs: "100%", sm: 400 } }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Employee Name"
                  size="small"
                  fullWidth
                />
              )}
            />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            sx={{
              height: 36,
              px: 2,
              borderRadius: 1,
              backgroundColor: "#1e3a8a",
              fontSize: "0.875rem",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#1e40af",
              },
            }}
            onClick={() => {
              if (!selectedEmployee) {
                setSnack({
                  open: true,
                  message: "Please select an employee first",
                  severity: "warning",
                });
                return;
              }

              setOpenAllocateConfirm(true);
            }}
          >
            Allocate
          </Button>
        </DialogActions>
      </Dialog>

      {/* Tranfser */}
      <Dialog
        open={openTransfer}
        onClose={() => setOpenTransfer(false)}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            Transfer Item
            <CloseModalIcon
              onClick={() => {
                setOpenTransfer(false);
              }}
            />
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box>
            <TableContainer
              component={Paper}
              sx={{
                mt: 2,
                maxWidth: "100%",
                overflowX: "auto",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Table
                size="small"
                sx={{
                  mb: 1,
                  borderCollapse: "collapse",

                  "& td": {
                    border: "none",
                    padding: "6px 8px",
                    verticalAlign: "middle",
                  },

                  "& td:nth-of-type(1), & td:nth-of-type(4)": {
                    fontWeight: "bold",
                    width: "200px",
                    whiteSpace: "nowrap",
                  },

                  "& td:nth-of-type(2), & td:nth-of-type(5)": {
                    width: "30px",
                    textAlign: "center",
                    paddingLeft: 0,
                    paddingRight: 0,
                  },

                  "& td:nth-of-type(3), & td:nth-of-type(6)": {
                    width: "250px",
                    whiteSpace: "nowrap",
                  },

                  "& tr:nth-of-type(even)": {
                    backgroundColor: "#f9f9f9",
                  },
                }}
              >
                <TableBody>
                  <TableRow>
                    <TableCell>Item Name</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell>
                      {iteminsuranceDetails?.ItemName || "-"}
                    </TableCell>

                    <TableCell>Item Code</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell>
                      {iteminsuranceDetails?.ItemCode || "-"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Department Id</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell>
                      {iteminsuranceDetails?.DepartmentId || "-"}
                    </TableCell>

                    <TableCell>GRN Date</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell colSpan={3}>
                      {iteminsuranceDetails?.GRNDate || "-"}
                    </TableCell>
                    {/* <TableCell>{formatDate(iteminsuranceDetails?.GRNDate)}</TableCell> */}
                  </TableRow>
                  <TableRow>
                    <TableCell>Installed Date</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell colSpan={3}>
                      {formatDate(iteminsuranceDetails?.InstalledDate)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <Box mt={3}>
              <div
                className="
                            mt-2
                            grid
                            grid-cols-1
                            sm:grid-cols-2
                            md:grid-cols-3
                            gap-4
                            "
              >
                <div>
                  <Autocomplete
                    options={[{ id: 45, label: "Purchase", value: "Purchase" }]}
                    value={fromDept}
                    disabled
                    getOptionLabel={(option) => option.label || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="From Department"
                        size="small"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                      />
                    )}
                  />
                </div>

                <div>
                  <Autocomplete
                    options={deptOptions}
                    loading={deptLoading}
                    getOptionLabel={(option) => option.label || ""}
                    onInputChange={(e, value, reason) =>
                      fetchDepartments(value, reason)
                    }
                    onChange={(e, value) => setToDept(value)}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="To Department"
                        size="small"
                        fullWidth
                        placeholder="Select department"
                      />
                    )}
                  />
                </div>

                <div>
                  <DatePickerField
                    control={control}
                    name="transferDate"
                    label="Transfer Date"
                    inputFormat="dd-MM-yyyy"
                  />
                </div>
              </div>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            sx={{
              height: 36,
              px: 2,
              borderRadius: 1,
              backgroundColor: "#1e3a8a",
              fontSize: "0.875rem",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#1e40af",
              },
            }}
            disabled={!fromDept || !toDept || !transferDate}
            onClick={() => {
              const payload = {
                itemId: selectedRow?.id,
                fromDepartmentId: fromDept.id,
                toDepartmentId: toDept.id,
                transferDate,
              };

              console.log("Transfer Payload:", payload);

              setOpenConfirm(true);
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Tranfser Approval */}
      <Dialog
        open={openApproval}
        onClose={() => setOpenApproval(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            Transfer Approval
            <CloseModalIcon
              onClick={() => {
                setOpenApproval(false);
              }}
            />
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box>
            {approvalLoading ? (
              <p style={{ textAlign: "center" }}>Loading...</p>
            ) : approvalTableData.length > 0 ? (
              <CommonDynamicTablePagination
                dataResult={approvalTableData}
                page={page}
                setPage={() => {}}
                rowsPerPage={10}
                setRowsPerPage={() => {}}
                count={approvalTableData.length}
                actionsRequired={true}
                highlightRow={true}
                removeHeaders={["Sr No."]}
                onRowClick={(row) => setSelectedApprovalRow(row)} // ✅ REQUIRED
              />
            ) : (
              <div className="flex flex-col items-center justify-center py-6 text-gray-400 text-sm">
                <svg width="40" height="40" fill="none" stroke="currentColor">
                  <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5l5 5v11a2 2 0 01-2 2z" />
                </svg>
                <p>No Records Found...</p>
              </div>
            )}
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            sx={{
              height: 36,
              px: 2,
              borderRadius: 1,
              backgroundColor: "#1e3a8a",
              fontSize: "0.875rem",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#1e40af",
              },
            }}
            onClick={() => setOpenApproveConfirm(true)}
          >
            Approval
          </Button>
        </DialogActions>
      </Dialog>

      {/* Allocation Confim */}
      <Dialog
        open={openAllocateConfirm}
        onClose={() => setOpenAllocateConfirm(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Allocation</DialogTitle>

        <DialogContent>
          Are you sure you want to allocate this item to the selected employee?
        </DialogContent>

        <DialogActions>
          <Button color="success" onClick={() => setOpenAllocateConfirm(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={async () => {
              const payload = {
                id: 0,
                itemInfoId: getItemInfoId(selectedRow), // ✅ FIXED
                employeeId: selectedEmployee?.value,
                departmentId: null,
                allocatedBy: 1,
                allocatedDateTime: new Date().toISOString(),
              };

              console.log("ALLOCATE PAYLOAD:", payload);

              try {
                await fetchAllocateSaveData(payload);

                setOpenAllocateConfirm(false);
                setOpenAllocation(false);

                setSelectedEmployee(null);
                setAllocationTableData([]);
                setAllocationCount(0);

                populateTable();
              } catch (error) {
                console.error("Allocation failed", error);
              }
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Tranfser Confim */}
      <Dialog
        open={openConfirm}
        onClose={() => setOpenConfirm(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Transfer</DialogTitle>

        <DialogContent>
          Are you sure you want to transfer this asset?
        </DialogContent>

        <DialogActions>
          <Button color="success" onClick={() => setOpenConfirm(false)}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={async () => {
              const payload = {
                itemInfoId: selectedRow?.["ItemInfo Id"],
                fromDeptId: fromDept.id,
                departmentId: toDept.id,
                transferBy: 1,
                transferDate: transferDate.toISOString(),
              };

              try {
                await fetchSaveTransfertData(payload);

                setTransferStatus((prev) => ({
                  ...prev,
                  [selectedRow["ItemInfo Id"]]: "requested",
                }));

                setOpenConfirm(false);
                setOpenTransfer(false);

                populateTable(); // 🔄 refresh list
              } catch (error) {
                console.error("Transfer save failed", error);
              }
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Tranfser Approval Confim */}
      <Dialog
        open={openApproveConfirm}
        onClose={() => {
          setOpenApproveConfirm(false);
          setApprovalError("");
        }}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Approval</DialogTitle>

        <DialogContent>
          Are you sure you want to approve this transfer?
          {approvalError && (
            <p style={{ color: "red", marginTop: 10 }}>{approvalError}</p>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            color="success"
            onClick={() => {
              setOpenApproveConfirm(false);
              setApprovalError("");
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={async () => {
              try {
                const payload = {
                  id: itemInfoId,
                  transferApprovedBy: 1,
                  transferApprovedDate: new Date().toISOString(),
                  isTransferApproved: true,
                };

                console.log("Approve payload:", payload);

                await approveTransfer(payload);

                // ✅ Remove approved row
                setApprovalTableData((prev) =>
                  prev.filter(
                    (row) =>
                      (row.itemInfoId ?? row["ItemInfo Id"]) !== itemInfoId,
                  ),
                );
                setTransferStatus((prev) => ({
                  ...prev,
                  [itemInfoId]: "approved",
                }));

                setOpenApproval(false);
                setOpenApproveConfirm(false);
                setSelectedApprovalRow(null);
              } catch (error) {
                console.error("Approval failed", error);
              }
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Insurance  */}
      <Dialog
        open={insuranceDialogOpen}
        onClose={() => {
          setInsuranceDialogOpen(false);
          setShowForm(false);
        }}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            Insurance Details
            <CloseModalIcon
              onClick={() => {
                setInsuranceDialogOpen(false);
                setShowForm(false);
              }}
            />
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box>
            <TableContainer
              component={Paper}
              sx={{
                mt: 2,
                maxWidth: "100%",
                overflowX: "auto",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Table
                size="small"
                sx={{
                  mb: 1,
                  borderCollapse: "collapse",

                  "& td": {
                    border: "none",
                    padding: "6px 8px",
                    verticalAlign: "middle",
                  },

                  "& td:nth-of-type(1), & td:nth-of-type(4)": {
                    fontWeight: "bold",
                    width: "200px",
                    whiteSpace: "nowrap",
                  },

                  "& td:nth-of-type(2), & td:nth-of-type(5)": {
                    width: "30px",
                    textAlign: "center",
                    paddingLeft: 0,
                    paddingRight: 0,
                  },

                  "& td:nth-of-type(3), & td:nth-of-type(6)": {
                    width: "250px",
                    whiteSpace: "nowrap",
                  },

                  "& tr:nth-of-type(even)": {
                    backgroundColor: "#f9f9f9",
                  },
                }}
              >
                <TableBody>
                  <TableRow>
                    <TableCell>Item Name</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell>
                      {iteminsuranceDetails?.ItemName || "-"}
                    </TableCell>

                    <TableCell>Item Code</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell>
                      {iteminsuranceDetails?.ItemCode || "-"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Department Id</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell>
                      {iteminsuranceDetails?.DepartmentId || "-"}
                    </TableCell>

                    <TableCell>GRN Date</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell colSpan={3}>
                      {iteminsuranceDetails?.GRNDate || "-"}
                    </TableCell>
                    {/* <TableCell>{formatDate(iteminsuranceDetails?.GRNDate)}</TableCell> */}
                  </TableRow>
                  <TableRow>
                    <TableCell>Installed Date</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell colSpan={3}>
                      {formatDate(iteminsuranceDetails?.InstalledDate)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <Box>
              {loading ? (
                <p style={{ textAlign: "center" }}>Loading...</p>
              ) : rows && rows.length > 0 ? (
                <CommonDynamicTablePagination
                  dataResult={rows}
                  page={page}
                  setPage={() => {}}
                  rowsPerPage={10}
                  setRowsPerPage={() => {}}
                  count={rows.length}
                  actionsRequired={false}
                  highlightRow={false}
                  removeHeaders={["Sr No."]}
                />
              ) : (
                <p style={{ textAlign: "center", color: "#777" }}>
                  <div className="flex flex-col items-center justify-center py-6 text-gray-400 text-sm">
                    <svg
                      width="40"
                      height="40"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5l5 5v11a2 2 0 01-2 2z" />
                    </svg>
                    <p>No Records Found...</p>
                  </div>
                </p>
              )}
            </Box>

            <Box
              display="grid"
              gridTemplateColumns="repeat(4, 1fr)"
              gap={2}
              mt={3}
            >
              <TextField
                label="Insurance No"
                size="small"
                fullWidth
                value={insuranceNo}
                onChange={(e) => setInsuranceNo(e.target.value)}
              />

              <Autocomplete
                options={insuranceTypeOptions}
                loading={insuranceTypeLoading}
                value={insuranceType}
                filterOptions={(x) => x}
                openOnFocus
                includeInputInList
                getOptionLabel={(option) => option?.value || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                onInputChange={(e, value, reason) =>
                  fetchInsuranceTypes(value, reason)
                }
                onChange={(e, value) => setInsuranceType(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Insurance Type"
                    size="small"
                    fullWidth
                  />
                )}
              />

              <TextField
                label="Insurance Amount"
                type="number"
                size="small"
                fullWidth
                value={insuranceAmount}
                onChange={(e) => setInsuranceAmount(e.target.value)}
              />

              <TextField
                label="Reference No"
                size="small"
                fullWidth
                value={referenceNo}
                onChange={(e) => setReferenceNo(e.target.value)}
              />

              <DatePickerField
                control={control}
                name="validFromDate"
                label="Valid From Date"
                inputFormat="dd-MM-yyyy"
              />

              <DatePickerField
                control={control}
                name="validToDate"
                label="Valid To Date"
                inputFormat="dd-MM-yyyy"
              />

              <InputField
                control={control}
                name="premiumAmount"
                label="Premium Amount"
                placeholder="Premium Amount"
                required
              />

              <DatePickerField
                control={control}
                name="premiumDate"
                label="Premium Date"
                inputFormat="dd-MM-yyyy"
              />

              <Autocomplete
                options={insuranceCompanyOptions}
                loading={insuranceCompanyLoading}
                value={insuranceCompany}
                filterOptions={(x) => x}
                openOnFocus
                includeInputInList
                getOptionLabel={(option) => option?.value || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                onInputChange={(e, value, reason) =>
                  fetchInsuranceCompanies(value, reason)
                }
                onChange={(e, value) => setInsuranceCompany(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Insurance Company"
                    size="small"
                    fullWidth
                  />
                )}
              />

              <Autocomplete
                options={insuranceAgentOptions}
                loading={insuranceAgentLoading}
                value={insuranceAgent}
                filterOptions={(x) => x}
                openOnFocus
                includeInputInList
                disabled={!insuranceCompany}
                getOptionLabel={(option) => option?.value || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                onInputChange={(e, value, reason) =>
                  fetchInsuranceAgents(value, reason)
                }
                onChange={(e, value) => setInsuranceAgent(value)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Insurance Agent"
                    size="small"
                    fullWidth
                  />
                )}
              />

              <TextField
                label="Remark"
                size="small"
                fullWidth
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                sx={{ gridColumn: "3 / span 2" }}
              />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            sx={{
              height: 36,
              px: 2,
              borderRadius: 1,
              backgroundColor: "#1e3a8a",
              fontSize: "0.875rem",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#1e40af",
              },
            }}
            onClick={() => setOpenInsuranceConfirm(true)}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Insurance Confim */}
      <Dialog
        open={openInsuranceConfirm}
        onClose={() => setOpenInsuranceConfirm(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Save</DialogTitle>

        <DialogContent>
          Are you sure you want to save this insurance details?
        </DialogContent>

        <DialogActions>
          <Button
            color="success"
            onClick={() => setOpenInsuranceConfirm(false)}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={async () => {
              try {
                // 1️⃣ SAVE DATA
                const payload = buildInsurancePayload();
                await fetchinsuranceSaveData(payload);

                // 2️⃣ CLOSE ONLY CONFIRM POPUP
                setOpenInsuranceConfirm(false);

                clearInsuranceForm();

                // 4️⃣ SHOW LIST VIEW (TABLE)
                setShowForm(false);

                // 5️⃣ FETCH UPDATED LIST (IMPORTANT)
                setLoading(true);
                const res = await InsuranceListing(insuranceItemInfoId);

                const updatedRows = Array.isArray(res?.data?.result)
                  ? res.data.result
                  : Array.isArray(res?.data)
                    ? res.data
                    : [];

                // 6️⃣ UPDATE TABLE STATE
                setRows(updatedRows);
                setLoading(false);

                // ❌ DO NOT close main dialog here
                setInsuranceDialogOpen(false);
              } catch (error) {
                console.error("Save failed", error);
                setLoading(false);
              }
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* AMC  */}
      <Dialog
        open={amcDialogOpen}
        onClose={() => {
          setAmcDialogOpen(false);
          setAmcShowForm(false);
        }}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            AMC Details
            <CloseModalIcon
              onClick={() => {
                setAmcDialogOpen(false);
                setAmcShowForm(false);
              }}
            />
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box>
            <TableContainer
              component={Paper}
              sx={{
                mt: 2,
                maxWidth: "100%",
                overflowX: "auto",
                borderRadius: 2,
                boxShadow: 1,
              }}
            >
              <Table
                size="small"
                sx={{
                  mb: 1,
                  borderCollapse: "collapse",
                  "& td": {
                    border: "none",
                    padding: "6px 8px",
                    verticalAlign: "middle",
                  },
                  "& td:nth-of-type(1), & td:nth-of-type(4)": {
                    fontWeight: "bold",
                    width: "200px",
                    whiteSpace: "nowrap",
                  },
                  "& td:nth-of-type(2), & td:nth-of-type(5)": {
                    width: "30px",
                    textAlign: "center",
                    paddingLeft: 0,
                    paddingRight: 0,
                  },
                  "& td:nth-of-type(3), & td:nth-of-type(6)": {
                    width: "250px",
                    whiteSpace: "nowrap",
                  },
                  "& tr:nth-of-type(even)": {
                    backgroundColor: "#f9f9f9",
                  },
                }}
              >
                <TableBody>
                  <TableRow>
                    <TableCell>Item Name</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell>{amcItemDetails.ItemName}</TableCell>

                    <TableCell>Item Code</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell>{amcItemDetails.ItemCode}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>Department Id</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell>{amcItemDetails.DepartmentId}</TableCell>

                    <TableCell>GRN Date</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell>{amcItemDetails.GRNDate}</TableCell>
                  </TableRow>

                  <TableRow>
                    <TableCell>Installed Date</TableCell>
                    <TableCell align="center">:</TableCell>
                    <TableCell colSpan={4}>
                      {formatDate(amcItemDetails?.InstalledDate)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>

            <Box>
              {amcLoading ? (
                <p style={{ textAlign: "center" }}>Loading...</p>
              ) : amcRows.length > 0 ? (
                <CommonDynamicTablePagination
                  dataResult={amcRows}
                  page={page}
                  setPage={() => {}}
                  rowsPerPage={10}
                  setRowsPerPage={() => {}}
                  count={amcRows.length}
                  actionsRequired={false}
                  highlightRow={false}
                  removeHeaders={["Sr No."]}
                />
              ) : (
                <p style={{ textAlign: "center", color: "#777" }}>
                  <div className="flex flex-col items-center justify-center py-6 text-gray-400 text-sm">
                    <svg
                      width="40"
                      height="40"
                      fill="none"
                      stroke="currentColor"
                    >
                      <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5l5 5v11a2 2 0 01-2 2z" />
                    </svg>
                    <p>No Records Found...</p>
                  </div>
                </p>
              )}
            </Box>

            <Box
              display="grid"
              gridTemplateColumns="repeat(4, 1fr)"
              gap={2}
              mt={3}
            >
              <TextField
                label="AMC No"
                size="small"
                fullWidth
                value={amcNo}
                onChange={(e) => setAmcNo(e.target.value)}
              />

              <Autocomplete
                options={amcTypeOptions}
                loading={amcTypeLoading}
                value={amcType}
                filterOptions={(x) => x}
                openOnFocus
                includeInputInList
                getOptionLabel={(o) => o?.value || ""}
                isOptionEqualToValue={(o, v) => o?.id === v?.id}
                onInputChange={(e, value, reason) =>
                  fetchAmcTypes(value, reason)
                }
                onChange={(e, v) => setAmcType(v)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="AMC Type"
                    size="small"
                    fullWidth
                  />
                )}
              />

              <TextField
                label="AMC Amount"
                type="number"
                size="small"
                fullWidth
                value={amcAmountValue}
                onChange={(e) => setAmcAmountValue(e.target.value)}
              />

              <TextField
                label="AMC Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                size="small"
                fullWidth
                value={amcDate}
                onChange={(e) => setAmcDate(e.target.value)}
              />

              <TextField
                label="From Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                size="small"
                fullWidth
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />

              <TextField
                label="To Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                size="small"
                fullWidth
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />

              <TextField
                label="Annual Guaranty"
                size="small"
                fullWidth
                value={annualGuaranty}
                onChange={(e) => setAnnualGuaranty(e.target.value)}
              />

              <TextField
                label="Per Visit Charge"
                type="number"
                size="small"
                fullWidth
                value={perVisitCharge}
                onChange={(e) => setPerVisitCharge(e.target.value)}
              />

              <Autocomplete
                options={maintenanceTypeOptions}
                loading={maintenanceTypeLoading}
                value={maintenanceType}
                filterOptions={(x) => x}
                openOnFocus
                includeInputInList
                getOptionLabel={(o) => o?.value || ""}
                isOptionEqualToValue={(o, v) => o?.id === v?.id}
                onInputChange={(e, value, reason) =>
                  fetchMaintenanceTypes(value, reason)
                }
                onChange={(e, v) => setMaintenanceType(v)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Maintenance Type"
                    size="small"
                    fullWidth
                  />
                )}
              />

              <TextField
                label="Last Maintenance Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                size="small"
                fullWidth
                value={lastMaintenanceDate}
                onChange={(e) => setLastMaintenanceDate(e.target.value)}
              />

              <Autocomplete
                options={amcAgentOptions}
                loading={amcAgentLoading}
                value={amcAgent}
                filterOptions={(x) => x}
                openOnFocus
                includeInputInList
                getOptionLabel={(o) => o?.value || ""}
                isOptionEqualToValue={(o, v) => o?.id === v?.id}
                onInputChange={(e, value, reason) =>
                  fetchAmcAgents(value, reason)
                }
                onChange={(e, v) => setAmcAgent(v)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="AMC Agent"
                    size="small"
                    fullWidth
                  />
                )}
              />

              <TextField
                label="Remark"
                size="small"
                fullWidth
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                // sx={{ gridColumn: "3 / span 2" }}
              />
            </Box>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            sx={{
              height: 36,
              px: 2,
              borderRadius: 1,
              backgroundColor: "#1e3a8a",
              fontSize: "0.875rem",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#1e40af",
              },
            }}
            onClick={() => setOpenAmcConfirm(true)}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* AMC Confim */}
      <Dialog
        open={openAmcConfirm}
        onClose={() => setOpenAmcConfirm(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Save</DialogTitle>

        <DialogContent>
          Are you sure you want to save this AMC details?
        </DialogContent>

        <DialogActions>
          <Button color="success" onClick={() => setOpenAmcConfirm(false)}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={async () => {
              try {
                const payload = buildAmcPayload();
                await fetchAmcSaveData(payload);

                // ✅ CLOSE CONFIRM POPUP ONLY
                setOpenAmcConfirm(false);

                // ✅ SWITCH TO LIST VIEW
                setAmcShowForm(false);

                // ✅ CLEAR FORM FIELDS
                setAmcNo("");
                setAmcType(null);
                setAmcAmountValue("");
                setAmcDate("");
                setFromDate("");
                setToDate("");
                setAnnualGuaranty("");
                setPerVisitCharge("");
                setMaintenanceType(null);
                setLastMaintenanceDate("");
                setAmcAgent(null);
                setRemark("");

                // ✅ REFRESH AMC TABLE IMMEDIATELY
                setAmcLoading(true);
                const res = await AmcListing(amcItemInfoId);

                if (Array.isArray(res?.data?.result)) {
                  setAmcRows(res.data.result);
                } else {
                  setAmcRows([]);
                }
                setAmcDialogOpen(false);
                setAmcLoading(false);
              } catch (error) {
                console.error("AMC save failed", error);
                setAmcLoading(false);
              }
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Upload Excel File */}
      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
        fullWidth
        maxWidth="sm"
        fullScreen={isMobile}
      >
        <DialogTitle>Upload Excel File</DialogTitle>

        <DialogContent>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: { xs: "stretch", sm: "center" },
              gap: 2,
              mt: 2,
            }}
          >
            <Button
              variant="outlined"
              component="label"
              fullWidth={isMobile}
              sx={{
                backgroundColor: "#e8f5e9",
                borderColor: "#81c784",
                color: "#2e7d32",
                "&:hover": {
                  backgroundColor: "#dcedc8",
                  borderColor: "#66bb6a",
                },
              }}
            >
              Choose Excel
              <input
                type="file"
                hidden
                accept=".xls,.xlsx"
                ref={fileInputRef}
                onChange={(e) => setFile(e.target.files[0])}
              />
            </Button>

            {file && (
              <Typography
                sx={{
                  wordBreak: "break-all",
                  fontSize: "0.9rem",
                }}
              >
                {file.name}
              </Typography>
            )}
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            color="success"
            onClick={() => setShowModal(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => setConfirmOpen(true)}
            disabled={loading || !file}
          >
            Upload
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Confirm Import</DialogTitle>

        <DialogContent>
          Are you sure you want to import this Excel file?
        </DialogContent>

        <DialogActions>
          <Button
            color="success"
            onClick={() => setConfirmOpen(false)}
            disabled={loading}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={confirmUpload}
            disabled={loading}
          >
            {loading ? "Importing..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snack.open}
        autoHideDuration={5000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snack.message}
        </Alert>
      </Snackbar>

      {/* Confirm Condemnation Yes / No */}
      <Dialog
        open={openCondemnConfirm}
        onClose={() => setOpenCondemnConfirm(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Condemnation</DialogTitle>

        <DialogContent>
          Are you sure you want to condemnation this item?
        </DialogContent>

        <DialogActions>
          <Button
            color="success"
            onClick={() => {
              setCondemnationStatus((prev) => ({
                ...prev,
                [selectedCondemnRow["ItemInfo Id"]]: "no",
              }));
              setOpenCondemnConfirm(false);
              setSelectedCondemnRow(null);
            }}
          >
            No
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={async () => {
              try {
                const payload = [
                  {
                    id: selectedCondemnRow["ItemInfo Id"],
                    isCondemn: true,
                    condemnRequestBy: 1, // 🔁 replace with logged-in user id
                    condemnReqDateAndTime: new Date().toISOString(),
                    condemnApprovedBy: 0,
                    condemnApprovedDateAndTime: null,
                  },
                ];

                await requestCondemnation(payload); // ✅ API CALL

                // ✅ Update icon
                setCondemnationStatus((prev) => ({
                  ...prev,
                  [selectedCondemnRow["ItemInfo Id"]]: "requested",
                }));

                setOpenCondemnConfirm(false);
                setSelectedCondemnRow(null);

                // OPTIONAL refresh
                populateTable();
              } catch (error) {
                console.error("Condemnation failed", error);
              }
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Condemnation Approval */}
      <Dialog
        open={openCondemnApproval}
        onClose={() => setOpenCondemnApproval(false)}
        maxWidth="lg"
        fullWidth
      >
        <DialogTitle>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            Condemnation Approval
            <CloseModalIcon onClick={() => setOpenCondemnApproval(false)} />
          </Box>
        </DialogTitle>

        <DialogContent>
          {condemnApprovalLoading ? (
            <p style={{ textAlign: "center" }}>Loading...</p>
          ) : condemnApprovalRows.length > 0 ? (
            <CommonDynamicTablePagination
              dataResult={condemnApprovalRows}
              page={page}
              setPage={() => {}}
              rowsPerPage={10}
              setRowsPerPage={() => {}}
              count={condemnApprovalRows.length}
              actionsRequired={true}
              highlightRow={true}
              removeHeaders={["Sr No."]}
              onRowClick={(row) => setSelectedCondemnApprovalRow(row)}
            />
          ) : (
            <div className="flex flex-col items-center justify-center py-6 text-gray-400 text-sm">
              <svg width="40" height="40" fill="none" stroke="currentColor">
                <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5l5 5v11a2 2 0 01-2 2z" />
              </svg>
              <p>No Records Found...</p>
            </div>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            sx={{
              height: 36,
              px: 2,
              borderRadius: 1,
              backgroundColor: "#1e3a8a",
              fontSize: "0.875rem",
              fontWeight: 600,
              "&:hover": {
                backgroundColor: "#1e40af",
              },
            }}
            onClick={() => setOpenCondemnApproveConfirm(true)}
          >
            Approve
          </Button>
        </DialogActions>
      </Dialog>

      {/* Confirm Condemnation Approval */}
      <Dialog
        open={openCondemnApproveConfirm}
        onClose={() => setOpenCondemnApproveConfirm(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Condemnation Approval</DialogTitle>

        <DialogContent>
          Are you sure you want to approve this condemnation?
        </DialogContent>

        <DialogActions>
          <Button
            color="success"
            onClick={() => setOpenCondemnApproveConfirm(false)}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="success"
            onClick={async () => {
              if (!selectedCondemnApprovalRow) return;

              const itemInfoId = getItemInfoId(selectedCondemnApprovalRow);
              if (!itemInfoId) {
                console.error("ItemInfoId missing");
                return;
              }

              try {
                const payload = [
                  {
                    id: itemInfoId,
                    isCondemn: true,
                    condemnRequestBy: 1,
                    condemnReqDateAndTime:
                      selectedCondemnApprovalRow.condemnReqDateAndTime,
                    condemnApprovedBy: 1,
                    condemnApprovedDateAndTime: new Date().toISOString(),
                  },
                ];

                console.log("CONDENM APPROVE PAYLOAD:", payload);

                // ✅ CALL API
                await approveCondemnation(payload);

                // ✅ REMOVE APPROVED ROW FROM APPROVAL TABLE
                setCondemnApprovalRows((prev) =>
                  prev.filter((row) => getItemInfoId(row) !== itemInfoId),
                );

                // ✅ UPDATE ICON STATUS → GREEN TICK
                setCondemnationStatus((prev) => ({
                  ...prev,
                  [itemInfoId]: "approved",
                }));

                // ✅ CLOSE DIALOGS
                setOpenCondemnApproveConfirm(false);
                setOpenCondemnApproval(false);
                setSelectedCondemnApprovalRow(null);
              } catch (error) {
                console.error("Condemn approval failed", error);
              }
            }}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snack.open}
        autoHideDuration={4000}
        onClose={() => setSnack({ ...snack, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }} // ✅ RIGHT SIDE
      >
        <Alert
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snack.message}
        </Alert>
      </Snackbar>

      <MaintenanceDialog
        maintenanceDialogOpen={maintenanceDialogOpen}
        onClose={() => {
          setMaintenanceDialogOpen(false);
          setMaintenanceShowForm(false);
        }}
        itemInfoId={maintenanceItemInfoId}
        itemDetails={selectedItemDetails}
        setSnack={setSnack}
      />

      <UpdateDialog
        updateDialogOpen={updateDialogOpen}
        onClose={() => {
          setUpdateDialogOpen(false);
          setUpdateShowForm(false);
        }}
        id={updateItemInfoId}
        setSnack={setSnack}
        onUpdateSuccess={updateRowInTable}
      />
    </Box>
  );
}
